// extracted by mini-css-extract-plugin
export default {"header":"B1Ewf","successActions":"_2z1Bj","desktop":"_2nRHx","title":"_3iGpJ","mobile":"_1zbch"};